import React, { useState } from 'react';
import { BurgerMenuContainer } from './styles';
import { useClickOutside } from 'customHook/useClickOutside';
import MainNav from 'components/MainNav';
import BurgerMenuIcon from 'assets/svg/BurgerMenu.svg';

const BurgerMenu = () => {
  const [open, setOpen] = useState(false);
  const { popUpRef, buttonRef } = useClickOutside(() => {
    setOpen(false)
  });

  return (
    <>
      <BurgerMenuContainer
        ref={buttonRef}
        open={open}
        onClick={() => setOpen(!open)}
      >
        <img src={BurgerMenuIcon} alt={'BurgerMenu'} />
      </BurgerMenuContainer>
      <MainNav
        popUpRef={popUpRef}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
};

export default BurgerMenu;


